import {
  defaultLocaleConfigs,
  getAppLanguageFromString,
  getDefaultLocaleByAppLanguage,
  type LocaleConfig,
} from 'platform/locale';

import {has, isNotNil} from 'ramda';

import {getSafely, Nullish} from 'shared/web';

import {additionalLocaleConfigs} from './additionalLocaleConfigs';

type AdditionalLanguage = keyof typeof additionalLocaleConfigs;

const isAdditionalLanguage = (language: string | Nullish): language is AdditionalLanguage =>
  isNotNil(language) && has(language, additionalLocaleConfigs);

/**
 * Default locale config for any language code (e.g. `fi`, `fi-FI`, `cs`).
 *
 * Covers the Omnetic UI languages (`AppLanguage`) and the additional languages
 * (e.g. the digital certificate ones). Unknown languages fall back to `en`.
 */
export function getLocaleConfigByLanguage(language: string | Nullish): LocaleConfig {
  const languageCode = language?.substring(0, 2);

  return isAdditionalLanguage(languageCode)
    ? getSafely(additionalLocaleConfigs, languageCode, defaultLocaleConfigs.en)
    : getDefaultLocaleByAppLanguage(getAppLanguageFromString(language));
}
